import ActionsMenu from '@enerex/unified-ui-react/ActionsMenu';
import EditIcon from '@enerex/unified-ui-react/icons/EditIcon';
import DeleteIcon from '@enerex/unified-ui-react/icons/DeleteIcon';
import AddIcon from '@enerex/unified-ui-react/icons/AddIcon';

const LookupActions = ({ record, onEdit, onDelete, onAddAliases }) => (
    <ActionsMenu align="end">
        {onAddAliases && <ActionsMenu.ActionItem onClick={() => onAddAliases(record)}>
            <span className="settings-lookup__action"><AddIcon /> Add Aliases</span>
        </ActionsMenu.ActionItem>}
        <ActionsMenu.ActionItem disabled={!onEdit} onClick={() => onEdit?.(record)}>
            <span className="settings-lookup__action"><EditIcon /> Edit</span>
        </ActionsMenu.ActionItem>
        <ActionsMenu.ActionItem disabled={!onDelete} onClick={() => onDelete?.(record)}>
            <span className="settings-lookup__action settings-lookup__action--delete"><DeleteIcon /> Delete</span>
        </ActionsMenu.ActionItem>
    </ActionsMenu>
);
export default LookupActions;
